export default __webpack_public_path__ + "static/media/refresh.43b95694.svg";